"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerReadiness = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = _interopRequireDefault(require("../ReadinessCheck"));
var _constants = require("../../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SpeakerReadiness = exports.SpeakerReadiness = function SpeakerReadiness(_ref) {
  var status = _ref.status,
    onSpeakerStatusChanged = _ref.onSpeakerStatusChanged,
    hideBottomBorder = _ref.hideBottomBorder,
    showSpeakerTest = _ref.showSpeakerTest,
    onSetShowSpeakerTest = _ref.onSetShowSpeakerTest,
    presenterId = _ref.presenterId;
  var _useState = (0, _react.useState)(status),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    speakerStatus = _useState2[0],
    setSpeakerStatus = _useState2[1];
  var onConfirm = function onConfirm(isWorking) {
    if (isWorking) {
      setSpeakerStatus(_constants.PASSED);
      onSpeakerStatusChanged(_constants.PASSED);
    } else {
      setSpeakerStatus(_constants.FAILED);
      onSpeakerStatusChanged(_constants.FAILED);
    }
  };
  var onRetry = function onRetry() {
    setSpeakerStatus(_constants.CHECKING);
    onSpeakerStatusChanged(_constants.CHECKING);
  };
  return _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading audio file....")
  }, _react["default"].createElement(_ReadinessCheck["default"], {
    title: "Speaker",
    status: speakerStatus,
    onRetry: onRetry,
    onConfirm: onConfirm,
    failedText: 'Speaker output not working',
    hideBottomBorder: hideBottomBorder,
    showSpeakerTest: showSpeakerTest,
    onSetShowSpeakerTest: onSetShowSpeakerTest,
    presenterId: presenterId
  }, _react["default"].createElement("p", null, "Is the speaker device connected and turned on?"), _react["default"].createElement("p", null, "Is the volume for the speaker turned up?"), _react["default"].createElement("p", null, "Review and confirm your default system speaker device.")));
};
SpeakerReadiness.defaultProps = {
  status: _constants.CHECKING
};
SpeakerReadiness.propTypes = {
  status: _propTypes.string.isRequired,
  onSpeakerStatusChanged: _propTypes.func,
  hideBottomBorder: _propTypes.bool,
  showSpeakerTest: _propTypes.bool,
  onSetShowSpeakerTest: _propTypes.func,
  presenterId: _propTypes.string
};